export function getDocumentBody() {
    if (typeof window === 'undefined') {
        return;
    }

    return document.body;
}
